<div class="chart-container">
  <ng-template #loading>
    <div class="loading-container">

      <section  class="loading-filters"  style="margin: auto">
        <div  class="pulsing">
          <mat-spinner [diameter]="50" ></mat-spinner>
        </div>
        <p class="pulsing">{{"Loading" | translate }}</p>
      </section>
    </div>
  </ng-template>

    <div class="row" *ngIf="graphAndFilters$ | async as graphAndFilters ; else loading">
      <div class="col-lg-9 mt-5">
        <a class="title" (click)="expandCollapseChart(!isExpanded)">
          <i class="bi bi-chevron-left"></i> {{ text_tittle | translate }}
        </a>
      </div>
      <div class="col-lg-6 mat-slide-toggle" *ngIf="helperService.user.role.roleId === 2 || helperService.user.role.roleId === 3 || helperService.user.role.roleId === 6">
        <mat-slide-toggle labelPosition="before" [(ngModel)]="ToggleAdvisor" (ngModelChange)="Grafic()">
          {{ "Advisor" | translate }}
        </mat-slide-toggle>
      </div>
      <div class="col-lg-6 mat-slide-toggle-hidden" *ngIf="helperService.user.role.roleId !== 2 && helperService.user.role.roleId !== 3 && helperService.user.role.roleId !== 6">
        <mat-slide-toggle labelPosition="before">
          {{ "Advisor" | translate }}
        </mat-slide-toggle>
      </div>
      <div class="col-lg-6 chart-dropdown">
        <mat-form-field class="marcas">
          <mat-label class="tlmarcas"> {{"Brand" | translate}} </mat-label>
          <mat-select  [(ngModel)]="marcaId">
            <mat-option
              *ngFor="let brands of graphAndFilters[1].brands"
              [value]="brands.brandId"
              (click)="Grafic()"
            >
              {{ brands.brandName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!-- Sucursales -->
        <mat-form-field class="marcas" 
           *ngIf="helperService.user.role.roleId === 3 || helperService.user.role.roleId === 4  || helperService.user.role.roleId === 5">
          <mat-label class="tlmarcas"> {{ "Workshop" | translate }} </mat-label>
          <mat-select  [(ngModel)]="sucursalId">
            <mat-option
              *ngFor="let workshop of graphAndFilters[1].workshops "
              [value]="workshop.workshopId"
              (click)="Grafic()"
            >
              {{ workshop.workshopName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!--LAPSOS DE TIEMPO-->
          <mat-form-field class="marcas">
            <mat-label class="tlmarcas"> </mat-label>
            <mat-select [(ngModel)]="selectDropDown">
              <mat-option *ngFor="let year of dropDownList" [value]="year"(click)="Grafic()">
                {{ year | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
      </div>
  </div>
  <ngx-charts-bar-vertical-stacked
    [scheme]="colorScheme"
    [results]="graphDashboard$ | async "
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [legend]="showLegend"
    [legendTitle]="''"
    [animations]="animations"
    [legendPosition]="legendPosition"
    [barPadding]="50"
  >
  </ngx-charts-bar-vertical-stacked>
</div>
